import type React from 'react';

import { Global } from '@change-corgi/design-system-legacy/core';
import { derivedGlobalStyle } from '@change-corgi/design-system-legacy/theme';

export const GlobalStyle: React.FC = () => {
	return (
		<Global
			styles={derivedGlobalStyle((theme) => ({
				body: {
					'.tox': {
						'.tox-toolbar,&:not(.tox-hugerte-inline) .tox-editor-header,.tox-toolbar__overflow,.tox-toolbar__primary,.tox-dialog__header,.tox-dialog__body,.tox-dialog__footer':
							{
								backgroundColor: `${theme.colors['primary-greyBackground']} !important`,
							},
						'.tox-editor-header .tox-tbtn:not(:hover):not(:active):not(.tox-tbtn--enabled)': {
							backgroundColor: 'transparent !important',
						},
						'.tox-button:not(.tox-button--icon):not(.tox-button--secondary):focus': {
							borderColor: theme.colors['primary-black'],
						},

						'.tox-button:not(.tox-button--icon):not(.tox-button--secondary):hover': {
							filter: 'brightness(0.8)',
							borderColor: theme.colors['primary-black'],
						},

						'.tox-button:not(.tox-button--icon):not(.tox-button--secondary)': {
							backgroundColor: theme.colors['primary-changeRed'],
							borderColor: theme.colors['primary-changeRed'],
							fontSize: '16px',
							lineHeight: '24px',
							minHeight: '44px',
							borderRadius: '8px',
							borderWidth: '2px',
							padding: '8px 22px',
						},

						'.tox-button--secondary:focus:not(:disabled)': {
							backgroundColor: theme.colors['primary-white'],
							borderWidth: '2px',
							borderColor: theme.colors['primary-black'],
							padding: '8px 22px',
						},

						'.tox-button--secondary:hover:not(:disabled)': {
							backgroundColor: theme.colors['primary-white'],
							borderWidth: '2px',
							borderColor: theme.colors['primary-black'],
							padding: '8px 22px',
						},

						'.tox-button--secondary': {
							backgroundColor: theme.colors['primary-white'],
							fontSize: '16px',
							lineHeight: '24px',
							minHeight: '44px',
							borderRadius: '8px',
							borderWidth: '1px',
							borderColor: theme.colors['neutral-grey600'],
							padding: '9px 23px',
						},

						'.tox-dialog__body-nav': {
							display: 'none',
						},
					},

					'.tox-hugerte': {
						borderRadius: '5px',
						borderColor: theme.colors['neutral-grey600'],
					},

					/* this removes the red banner notification hugerte displays on image upload error or when reject() is called */
					'.tox-notifications-container': {
						display: 'none',
					},

					/* this removes the outline when focused */
					'.tox .tox-edit-area::before': {
						borderWidth: '0 !important',
					},
				},
			}))}
		/>
	);
};
